﻿export class ValidationContainer {
    IsValid: boolean;
    Message: string;
}
